import React from "react";
import "./profilePost.sass"
import strr from "../../../../img/profileImg/strr.png"
import strl from "../../../../img/profileImg/strl.png"
const ProfilePost = ({img, name, textPost, changeCommentRight, changeCommentLeft, numberComments, numberCommentsInArray}) => {
    return(
        <div className='profile__post profile__main-blocks'>
            <div className="profile__info-number-comment additional-text"><p>{numberComments + 1} / {numberCommentsInArray}</p></div>
            {numberComments > 0 ? <div className='arrow' onClick={changeCommentLeft}><img src={strl} alt=""/></div> : null}
            <div className="profile__sender">
                <div><img src={img} alt="Аватарка"/></div>
                <div className='profile__post-text'>
                    <p className='additional-text'>"{textPost}"</p>
                    <p className='main-text name-with-line'>{name}</p>
                </div>
            </div>
            {numberComments < (numberCommentsInArray - 1) ? <div className='arrow' onClick={changeCommentRight}><img src={strr} alt=""/></div>: null}
        </div>
    )
};

export default ProfilePost;